import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { useQueryClient } from "@tanstack/react-query"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { Password } from "primereact/password"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Link, Redirect } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import * as Yup from "yup"
import "../pages/Login/login.scss"
import { login, userSelector } from "../redux/slices/userSlice"

const LoginForm = ({
  handleChange,
  values,
  errors,
  handleSubmit,
  handleBlur,
  touched,
  interno = false,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { fetching = false, logged } = useSelector(userSelector)

  useEffect(() => {
    // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par...
    sessionStorage.setItem("session_type", interno ? 0 : 1)
    queryClient.clear()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interno])

  if (logged) return <Redirect to={ROUTES.DASHBOARD} />
  const hasErrors = (key: $TSMigrationFixMe) => {
    return errors[key] && touched[key]
  }

  const passwordErrors = hasErrors("password")

  return (
    <form
      autoComplete='off'
      className='mt-5 text-left form-login'
      onSubmit={handleSubmit}
    >
      <h4 className='mt-5 text-white f-24'>
        {t("login.title")} {interno ? `- ${t("login.subTitle")}` : ""}
      </h4>

      <div className='mt-4 p-field'>
        <label
          className='text-white'
          htmlFor='email'
        >
          {interno ? `${t("login.labelUser")}` : `${t("login.labelMail")}`}
        </label>

        <div className='w-full'>
          <FormikInputText
            placeholder={
              interno
                ? `${t("login.placeholderUserName")}`
                : `${t("login.placeholderUserMail")}`
            }
            autoFocus
            noSpaces
            className='w-full'
            name='email'
            id='username'
          />
        </div>
      </div>

      <div className='mt-3 p-field'>
        <label
          htmlFor='password'
          className='w-100 d-flex justify-content-between'
        >
          <span className='text-white'>{t("login.labelPassword")}</span>
        </label>

        <Password
          name='password'
          id='password'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          placeholder={`${t("login.placeholderPassword")}`}
          toggleMask
          feedback={false}
          inputClassName='w-full'
          className={`${passwordErrors ? "p-invalid p-d-block" : ""} w-full`}
        />

        {passwordErrors && (
          <small className='p-error p-d-block'>{errors.password}</small>
        )}
      </div>

      {!interno && (
        <>
          <div className='justify-end w-full d-flex'>
            <Link
              tabIndex={-1}
              to={ROUTES.RECOVERY_PASSWORD_STEP_1}
            >
              <span className='text-white'>{t("login.forgotPassword")}</span>
            </Link>
          </div>

          <p className='my-4 text-white'>
            {t("login.createAccountQuestion")}{" "}
            <Link
              onMouseDown={(e) => e.preventDefault()}
              to={ROUTES.SIGN_UP}
            >
              <b className='text-white '>{t("login.createAccountOpen")}</b>
            </Link>
          </p>
        </>
      )}

      <ButtonPrimeReact
        type='submit'
        disabled={fetching}
        className='tw-w-full !tw-px-6 !tw-py-3 !tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none !tw-rounded-[99px] tw-text-simple-10'
      >
        {t("login.initSesion")}
        {fetching && (
          <div
            className='ml-2 spinner-border text-light spinner-border-sm'
            role='status'
          >
            <span className='sr-only'>{t("login.loading")}</span>
          </div>
        )}
      </ButtonPrimeReact>
    </form>
  )
}

const isIterno = window.location.pathname.includes(ROUTES.LOGIN_INTERNO_BACKUP)
const validateLogin = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    email: Yup.string().required(
      isIterno ? t("errors.userEmpty") : t("errors.emptyMail")
    ),
    password: Yup.string().required(t("errors.passwordEmpty")),
  })

const Login = withFormik({
  mapPropsToValues: () => ({
    email: "",
    password: "",
    interno: isIterno,
  }),
  validationSchema: ({ t }: $TSMigrationFixMe) => validateLogin(t),
  handleSubmit: (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'login' does not exist on type 'object'.
    props.login(values)
  },
})(LoginForm)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  login: (payload: $TSMigrationFixMe) => dispatch(login(payload)),
})

export default connect(null, mapDispatchToProps)(Login)
